module.exports = __webpack_public_path__ + "static/media/video-poster.47fced02.png";